<template>
    <v-dialog v-model="cargar" :max-width="tamModal" :fullscreen="$root.isTouch"
                :scrollable="$root.isTouch == false" persistent>
        <v-card flat>
            <v-card-title class="bg-title-card"><span class="white--text headline" v-html="formTitle" /></v-card-title>
            <v-card-text>
                <v-form ref="form_proveedor">
                    <v-container>
                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-autocomplete label="Tipo de Documento *" color="textbox"
                                    v-model="objModal.idTipoDocumento" :items="listaTipoDocumento" item-text="tipoDocumento"
                                    item-value="idTipoDocumento" :rules="requeridoRegla" outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Número de Documento *" color="textbox" v-model="objModal.nroDocumento"
                                    outlined dense :rules="_.concat(requeridoRegla,validacion)" />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-autocomplete label="Beneficio *" color="textbox" v-model="objModal.beneficios"
                                    :items="listaCoberturaAdicional" item-text="decision" item-value="idDecision"
                                    :rules="requeridoRegla" outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="8">
                                <v-text-field label="Nombre*" color="textbox" v-model="objModal.nombre"
                                    :rules="_.concat(requeridoRegla,max300Regla)" counter="300" outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-autocomplete label="Servicio Complementario *" color="textbox"
                                    v-model="objModal.servicioComplementario" outlined dense :rules="requeridoRegla"
                                    :items="listaCoberturaAdicional" item-text="decision" item-value="idDecision">
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-text-field label="Dirección" color="textbox" v-model="objModal.direccion"
                                    :rules="_.size(objModal.direccion) > 0 ? max300Regla : []" counter="300" outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Teléfono Pbx" color="textbox" v-model="objModal.telefonoPbx"
                                    :mask="'(###) ### - ####'"
                                    :rules="_.size(objModal.telefonoPbx) > 0 ? soloNumerosRegla(8,objModal.telefonoPbx,10) : []"
                                    outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field label="Celular" color="textbox" v-model="objModal.celular"
                                    :mask="'(###) ### - ####'"
                                    :rules="_.size(objModal.celular) > 0 ? soloNumerosRegla(10,objModal.celular,10) : []"
                                    outlined dense />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-autocomplete label="Estado*" color="textbox" v-model="objModal.estado"
                                    :rules="requeridoRegla" item-text="nombre_estado" item-value="id_estado" outlined dense
                                    :items="listaEstados"></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-spacer />
                            <v-col class="text-right">
                                <v-btn outlined rounded class="mr-1" color="danger" @click="close();reset();" :disabled="disabled">Cancelar</v-btn>
                                <v-btn rounded dark color="primary" @click="submit" :disabled="disabled">Guardar</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
    export default {
        props:{
            cargar:{ type: Boolean, default : false },
            objProveedorEditar:{ type: Object, default : {} },
            formTitle:{ type: String, default : '' },
            listDecision:{ type: Array, default: () => [] },
            listEstados:{ type: Array, default: () => [] },
            listTipoDocumento:{ type: Array, default: () => [] },
        },
        inject: ['close', 'save'],
        data:() => ({
            objModal: {},
            disabled: false
        }),
        watch:{
            cargar(val){
                if(val){
                    this.reset();
                    this.$set(this, 'objModal', _.clone(this.objProveedorEditar));
                }
            }
        },
        computed: {
            listaEstados: function () {
                return _.filter(this.listEstados, (obj) => { return _.toUpper(obj.visualiza) == _.toUpper('true') });
            },
            listaCoberturaAdicional: function () {
                return _.filter(this.listDecision, (obj) => { return _.toUpper(obj.visualiza) == _.toUpper('true') });
            },
            listaTipoDocumento: function () {
                return _.filter(this.listTipoDocumento, (obj) => { return _.toUpper(obj.visualiza) == _.toUpper('true') });
            },
            validacion: function () {
                var v = "cedula";

                if (!_.isUndefined(this.objModal.idTipoDocumento)) {
                    v = _.find(this.listTipoDocumento, (o) => {  return o.idTipoDocumento == this.objModal.idTipoDocumento });
                    v = _.size(v.tipoDocumento) > 0 ? _.toLower(v.tipoDocumento) : v;
                }
                return this[v];
            }
        },
        methods: {
            submit() {
                if (this.$refs.form_proveedor.validate()) {
                    this.disabled = true;
                    this.save(_.merge({}, this.objProveedorEditar,this.objModal))
                        .then((r) => {
                            if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                this.reset();
                        })
                        .catch((e)=>{
                            this.disabled = false;
                        })
                } else
                    mensajesAlerta(mensajeEstandar.corregirInformacion, 'I');
            },
            reset() {
                if(!_.isUndefined(this.$refs.form_proveedor))
                    this.$refs.form_proveedor.resetValidation();

                this.$set(this, 'objModal', {});
            },
        }
    }
</script>